export default function getLang() {
  return document.documentElement.lang.substring(0, 2);
}
